import 'css-chunk:src/index/pages/notification/index.module.scss';export default {
  "tablet": "tablet__FIuR-",
  "sp": "sp__AkCjo",
  "pc": "pc__yEZsP",
  "pcTablet": "pcTablet__fK0qt",
  "section": "section__w5vpK",
  "relative": "relative__ThFE0",
  "row": "row__bWYOh",
  "middle": "middle__7X4Al",
  "formLabel": "formLabel__JsZXF",
  "formLabel2": "formLabel2__Y-USH",
  "formLabelIssue": "formLabelIssue__DuF7e",
  "item": "item__FBoKH",
  "title": "title__nHMzD",
  "msg": "msg__zFsYt",
  "type": "type__hX483",
  "companyName": "companyName__UK7uV",
  "content": "content__Z6Br-",
  "nestContent": "nestContent__-NKVc",
  "statusArea": "statusArea__Ghrit",
  "status": "status__VCm78",
  "priority": "priority__uSt4D",
  "description": "description__fxHCh",
  "area": "area__4pxDA"
};